module.exports = __webpack_public_path__ + "static/media/boomplay.4886accd.pdf";